module.exports = __webpack_public_path__ + "static/media/zeder_home.301033be.png";